export default {
      id: "provider-icon-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "icons.svg#provider-icon",
      toString: function () {
        return this.url;
      }
    }